"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSchedulerSchema = void 0;
var zod_1 = require("zod");
// do not use for inferring the type
exports.AdSchedulerSchema = zod_1.z.object({
    get: zod_1.z.function(),
    update: zod_1.z.function(),
});
//# sourceMappingURL=ad-scheduler.js.map